module.exports = "<div class=\"modal-detail-container hide-modal-detail\">\r\n    <div class=\"modal-detail\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"modal-detail-mask\"></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-detail-doc/modal-detail-doc.component.html
// module id = ./src/app/shared/components/modal-detail-doc/modal-detail-doc.component.html
// module chunks = main